import {Card, Icon} from '@ezcater/tapas';
import {faArrowRight, type IconDefinition} from '@fortawesome/pro-solid-svg-icons';

export type ResumeCardInfoRow = {
  icon: IconDefinition;
  label: string;
};

type ResumeCardProps = {
  href: string;
  image: React.ReactNode;
  infoRows: ResumeCardInfoRow[];
  onClick: () => void;
  title: string;
};

const ResumeCard: React.FC<ResumeCardProps> = ({href, image, infoRows, onClick, title}) => (
  <Card className="h-full rounded-3xl border-peppercorn-100 p-0 transition duration-250 ease-out hover:border-ezo-card-hover-border hover:shadow-md">
    <a
      className="flex h-full flex-col gap-4 rounded-3xl p-4 no-underline hover:no-underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-peppercorn-800 tablet:flex-row tablet:items-center tablet:p-6"
      href={href}
      onClick={onClick}
    >
      <div className="order-last flex min-w-0 flex-col gap-1 tablet:order-none tablet:flex-1">
        <div className="flex items-end gap-1 text-base font-bold leading-[22px] text-peppercorn-800 tablet:text-lg tablet:leading-6">
          <span className="line-clamp-2 min-w-0 [overflow-wrap:anywhere]">{title}</span>
          <Icon aria-hidden className="mb-1 shrink-0" icon={faArrowRight} size="xsmall" />
        </div>
        <div className="flex flex-col gap-0.5">
          {infoRows.map(row => (
            <div
              className="flex items-center gap-3 text-sm leading-5 text-peppercorn-800 tablet:text-base tablet:leading-[22px]"
              key={row.label}
            >
              <span className="flex size-4 shrink-0 items-center justify-center">
                <Icon aria-hidden className="text-base tablet:text-xl" icon={row.icon} />
              </span>
              <span className="truncate">{row.label}</span>
            </div>
          ))}
        </div>
      </div>
      {image}
    </a>
  </Card>
);

export default ResumeCard;
